import { PROFILE_KNOWLEDGE_CHAPTERS } from '../profileContract';
import { getKnowledgeItemProfileChapterId } from '../knowledgeItems/careKnowledgeProfileGrouping';

const clean = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

const getSavedKnowledgeItems = (source = {}) => [
  ...(Array.isArray(source.primaryProfileKnowledgeItems) ? source.primaryProfileKnowledgeItems : []),
  ...(Array.isArray(source.careKnowledgeSavedItems) ? source.careKnowledgeSavedItems : []),
  ...(Array.isArray(source.metadata?.careSourceProcessing?.careKnowledgeSavedItems)
    ? source.metadata.careSourceProcessing.careKnowledgeSavedItems
    : []),
];

const getSuggestionById = (source = {}) => new Map(
  (Array.isArray(source.suggestedCareKnowledgeItems) ? source.suggestedCareKnowledgeItems : [])
    .map((item) => [clean(item.clientId || item.id), item])
    .filter(([id]) => id)
);

const getSavedItemText = (item = {}) => clean(
  item.content || item.summary || item.title || item.sourceText
);

export const buildCaptureDestinationReceipt = (sources = []) => {
  const sectionsByChapter = new Map(PROFILE_KNOWLEDGE_CHAPTERS.map((chapter) => [
    chapter.chapterId,
    { ...chapter, items: [], itemKeys: new Set() },
  ]));
  sources.forEach((source) => {
    const suggestionById = getSuggestionById(source);
    getSavedKnowledgeItems(source).forEach((item) => {
      const itemId = clean(item.clientId || item.id);
      const suggestion = suggestionById.get(itemId) || {};
      const chapterId = getKnowledgeItemProfileChapterId({
        ...suggestion,
        ...item,
      });
      const section = sectionsByChapter.get(chapterId);
      const text = getSavedItemText(item) || getSavedItemText(suggestion);
      const itemKey = text.toLowerCase();
      if (!section || !itemKey || section.itemKeys.has(itemKey)) return;
      section.itemKeys.add(itemKey);
      section.items.push(text);
    });

  });

  const profileSections = Array.from(sectionsByChapter.values())
    .filter((section) => section.items.length)
    .map((section) => ({
      chapterId: section.chapterId,
      profileViewId: section.profileViewId,
      label: section.label,
      items: section.items,
    }));

  return { profileSections };
};
